// extracted by mini-css-extract-plugin
export var linkText = "_n2-0";